import { useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { fmtDate } from "./shared";

export const effectiveLevel = (ratings, ai, rid, key) => {
  const manual = ratings[rid]?.[key];
  if (manual !== undefined && manual !== null) return { value: manual, source: "manual" };
  const est = ai[rid]?.[key];
  if (est !== undefined && est !== null) return { value: est, source: "ai" };
  return { value: null, source: null };
};

export const StModesChart = ({ sessions, ratings, ai, modes }) => {
  const [hidden, setHidden] = useState(() => new Set(modes.filter((m) => m.group === "coping" && m.key !== "detached_protector").map((m) => m.key)));
  const data = sessions.map((s) => {
    const row = { name: `#${s.session_number}`, date: fmtDate(s.session_date) };
    modes.forEach((m) => { row[m.key] = effectiveLevel(ratings, ai, s.report_id, m.key).value; });
    return row;
  });
  const toggle = (k) => setHidden((h) => { const n = new Set(h); n.has(k) ? n.delete(k) : n.add(k); return n; });
  const hasData = data.some((r) => modes.some((m) => r[m.key] !== null));
  return (
    <div className="rounded-xl border bg-card p-4 space-y-3" data-testid="st-modes-chart">
      <div className="flex flex-wrap gap-1.5" data-testid="st-modes-toggles">
        {modes.map((m) => (
          <button key={m.key} onClick={() => toggle(m.key)} className={`text-[11px] px-2 py-0.5 rounded-full border transition-colors ${hidden.has(m.key) ? "bg-background text-muted-foreground border-border line-through" : "text-white"}`} style={hidden.has(m.key) ? {} : { backgroundColor: m.color, borderColor: m.color }} data-testid={`st-modes-toggle-${m.key}`}>{m.label}</button>
        ))}
      </div>
      {!hasData ? (
        <p className="text-sm text-muted-foreground text-center py-8" data-testid="st-modes-chart-empty">Aucune cotation pour l'instant : cotez les modes séance par séance ou lancez l'estimation IA.</p>
      ) : (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 8, right: 16, left: -16, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
              <XAxis dataKey="name" tick={{ fontSize: 11 }} />
              <YAxis domain={[0, 10]} ticks={[0, 2, 4, 6, 8, 10]} tick={{ fontSize: 11 }} />
              <Tooltip labelFormatter={(l, p) => `Séance ${l} · ${p?.[0]?.payload?.date || ""}`} contentStyle={{ fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              {modes.filter((m) => !hidden.has(m.key)).map((m) => <Line key={m.key} type="monotone" dataKey={m.key} name={m.label} stroke={m.color} strokeWidth={2} dot={{ r: 3 }} connectNulls />)}
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};
